// ======================================================================
// CurrentStockPage.jsx
// PPE → Inventory → Reports → Current Stock
// ======================================================================

import React, { useEffect, useState } from "react";
//import { fetchCurrentStock } from "./currentStockService";

import ERPReportLayout from
"../../../../components/reports/ERPReportLayout";

import ERPFilterBar from
"../../../../components/reports/ERPFilterBar";

import ERPDataGrid from
"../../../../components/reports/ERPDataGrid";

import ERPReportActions from
"../../../../components/reports/ERPReportActions";

import "../../../../components/reports/reportStyles.css";

import {
  fetchCurrentStock,
  exportCurrentStockExcel
} from "./currentStockService";


export default function CurrentStockPage() {

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(20);

  const [filters, setFilters] = useState({
    material: "",
    warehouse: "",
    batch: ""
  });

  

  // -------------------------------------------------------
  // LOAD DATA
  // -------------------------------------------------------
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await fetchCurrentStock(filters);
      setRows(data.rows || []);
    } catch (err) {
      console.error("Failed to load current stock", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // -------------------------------------------------------
  // EXPORT HANDLER (ERP STANDARD)
  // -------------------------------------------------------
  const handleExport = async (format) => {

  try {

    if (format !== "xlsx") {
      alert("PDF export not implemented yet");
      return;
    }

    const blob =
      await exportCurrentStockExcel(filters);

    const url =
      window.URL.createObjectURL(
        new Blob([blob])
      );

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      "current_stock.xlsx"
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {

    console.error(err);

    alert(
      "Failed to export report"
    );
  }
};
  // -------------------------------------------------------
  // KPI CALCULATION
  // -------------------------------------------------------
  const totalQty = rows.reduce(
    (s, r) => s + Number(r.available_qty || 0),
    0
  );

  const totalPages = Math.ceil(
  rows.length / pageSize
);

const paginatedRows = rows.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);

const pageNumbers = Array.from(
  { length: totalPages },
  (_, i) => i + 1
);
  
  // -------------------------------------------------------
  // GRID COLUMN CONFIG (ERP STANDARD)
  // -------------------------------------------------------
  const columns = [
    {
      key: "material_name",
      label: "Material",
      bold: true,
    },
    {
      key: "material_type",
      label: "Type",
    },
    {
      key: "warehouse_id",
      label: "Warehouse",
      render: (r) => `WH-${r.warehouse_id}`,
    },
    {
      key: "batch_no",
      label: "Batch",
      render: (r) => r.batch_no || "-",
    },
    {
      key: "available_qty",
      label: "Available Qty",
      align: "right",
      render: (r) =>
        Number(r.available_qty || 0).toFixed(2),
    },
  ];

  // -------------------------------------------------------
  // FILTER BAR
  // -------------------------------------------------------
  const filterBar = (
    <ERPFilterBar
      left={
        <>
          <input
            value={filters.material}
            placeholder="Material"
            className="erp-filter"
            onChange={(e) =>
              setFilters(prev => ({
                ...prev,
                material: e.target.value
              }))
            }
          />

          <input
            value={filters.warehouse}
            placeholder="Warehouse"
            className="erp-filter"
            onChange={(e) =>
              setFilters(prev => ({
                ...prev,
                warehouse: e.target.value
              }))
            }
          />

          <input
            value={filters.batch}
            placeholder="Batch"
            className="erp-filter"
            onChange={(e) =>
              setFilters(prev => ({
                ...prev,
                batch: e.target.value
              }))
            }
          />

          <button
            onClick={loadData}
            className="erp-primary-btn"
          >
            Search
          </button>
        </>
      }

      right={
        <div className="flex items-center gap-4">

            <div className="text-sm text-gray-700 whitespace-nowrap">
            Total Qty :
            <strong className="ml-1 text-indigo-600">
                {totalQty.toFixed(2)}
            </strong>
            </div>

            <ERPReportActions onExport={handleExport} />

        </div>
        }

    />
  );

  // =====================================================
  // UI
  // =====================================================
  return (
    <ERPReportLayout
      title="Inventory — Current Stock"
      subtitle="View available stock across warehouses"
      toolbar={filterBar}
    >

      <ERPDataGrid
        columns={columns}
        rows={paginatedRows}
        loading={loading}
      />

      <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

      <div>
        Showing{" "}
        {(currentPage - 1) * pageSize + 1}
        {" - "}
        {Math.min(
          currentPage * pageSize,
          rows.length
        )}
        {" of "}
        {rows.length}
        {" records"}
      </div>

      <div className="d-flex align-items-center gap-2">

        <span>Rows:</span>

        <select
          className="form-select form-select-sm"
          style={{ width: "90px" }}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === 1}
          onClick={() => setCurrentPage(1)}
        >
          {"<<"}
        </button>

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === 1}
          onClick={() =>
            setCurrentPage(currentPage - 1)
          }
        >
          {"<"}
        </button>

        {pageNumbers.map((page) => (
          <button
            key={page}
            className={
              page === currentPage
                ? "btn btn-sm btn-primary"
                : "btn btn-sm btn-outline-secondary"
            }
            onClick={() =>
              setCurrentPage(page)
            }
          >
            {page}
          </button>
        ))}

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage(currentPage + 1)
          }
        >
          {">"}
        </button>

        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage(totalPages)
          }
        >
          {">>"}
        </button>

      </div>

    </div>

    </ERPReportLayout>
  );
}
